/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSpecialDetail.vue?vue&type=template&id=f32dbeac&scoped=true"
import script from "./popSpecialDetail.vue?vue&type=script&lang=js"
export * from "./popSpecialDetail.vue?vue&type=script&lang=js"
import style0 from "./popSpecialDetail.vue?vue&type=style&index=0&id=f32dbeac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32dbeac",
  null
  
)

export default component.exports